export const VEHICLES_BUCKET = 'https://cdn.veloxwheels.com'
export const BRAND_BUCKET = 'https://cdn.veloxwheel.com/brand'
export const PRODUCTS_BUCKET = 'https://cdn.veloxwheel.com/products/png'
export const WHEELS_SIDE_BUCKET = 'https://cdn.veloxwheels.com/products/side'
export const IMG_DIR_BASE = 'https://cdn.veloxwheels.com'
export const UI_IMG_BUCKET = IMG_DIR_BASE + '/ui'

export const SORT_OPTIONS = [
	{ 	'name': 'Price',	'field': 'current_price'	}
]

export const SORT_DIRECTIONS = [
	{ 	'name': 'Ascending',	'value': 'asc'			},
	{ 	'name': 'Descending',	'value': 'desc'			}
]